const doc = [({"en":({"js":({"proposal_types":({"presenter_card":({"deadline_for_proposals_at":"Deadline for proposals at %{date_time}", "count_of_propoals":"%{count} proposals"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;